import { useState } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";
import { POPUP_CONTENTS } from "../modules/extension/utils/constants";
import { useExtensionContext } from "../modules/extension/ExtensionContext";

const useDealTransfer = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { setState, refetchDeals, setSelectedDeal } = useExtensionContext();

    const transferDeal = async ({ dealId, targetId, profilId }) => {
        if (!dealId || !targetId || !profilId) {
            toast.error("Required information is missing.");
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const response = await post({
                fn: "dealTransfer",
                dealId,
                targetId,
                profilId,
            });
            toast.success("Deal successfully transferred.");
            //await refetchProfile();
            await refetchDeals();
            await setState((prevState) => ({
                ...prevState,
                popupContent: POPUP_CONTENTS.DEALS,
                popupIsOpen: true,
            }));
            await setSelectedDeal(null);

            return response;
        } catch (err) {
            toast.error(err.response?.data?.text || "Transfer operation failed.");
            setError(err);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return { loading, error, transferDeal };
};

export default useDealTransfer;
